import { setCookie } from '@/utils/cookieSetter'

export const setCheckoutCookies = (growthbookFlags) => {
  const cookieOptions = {
    path: '/',
    domain: '.gocase.com.br',
    'Max-Age': 86400,
    SameSite: 'None',
    Secure: true,
  }
  Object.entries(growthbookFlags).forEach(([name, value]) => {
    setCookie(name, value, cookieOptions)
  })
}

export const getCheckoutUrl = ({
  isBrStore = typeof globalThis.$isBrStore === 'boolean'
    ? globalThis.$isBrStore
    : true,
  checkoutURL = 'https://checkout.gocase.com.br/checkout',
  checkoutGlobalURL,
  locale,
}) => {
  return isBrStore
    ? checkoutURL
    : `${checkoutGlobalURL}?language=${locale || 'en'}`
}

export const redirectToCheckout = (state) => {
  setCheckoutCookies(state.growthbook)
  window.open(getCheckoutUrl(state), '_self')
}
